<template>
  <section class="hero">
    <div>
      <h1>找兼职？招兼职？<br>就上兼职直聘！</h1>
      <p>100万+ 用户认证 · 全国300+ 城市覆盖<br>找工作更安心，招兼职更高效</p>
      <div>
        <a
          class="btnFindJob"
          target="_blank" :href="util.getJzzpH5Url()">
          我要找兼职
        </a>
        <a class="btnFindMember" @click="findMan()">开始招人</a>
      </div>
      <CenterDialog
        :visible.sync="show"
        type="image"
        width="240px"
        title="请长按识别前往小程序继续操作"
        :image="imageQrcode"
        :showActions="false"
      />
    </div>
  </section>
</template>

<script>
import CenterDialog from "@/views/toc/ShowImageDialog.vue";
import store from "@/store";
import router from "@/router";

export default {
  name: 'HeroSection',
  components: {CenterDialog},
  data() {
    return {
      show: false,
      imageQrcode: require('@/assets/img/qrcode_shangjia.jpg'),
    }
  },
  methods: {
    findMan(){
      if(this.util.isInMobileWx()){
        this.show = true;
        return
      }
      if (store.state.token){
        router.push('/hometoc')
      } else {
        router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.hero {
  padding-top: 50px; /* 避开 fixed header */
  height: 500px;
  background-image: url('~@/assets/img/homt_bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  padding-left: 10%;
  color: white;
}

.btnFindJob{
  height: auto;
  padding: 12px 15px;
  margin-right: 20px;
  color: #101010;
  background: #FFFFFFB3;
  border-radius: 20px;
  border: 0;
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4) !important;
}

.btnFindMember{
  height: auto;
  color: #101010;
  background: #FAA269B3;
  padding: 12px 15px;
  border: 0;
  border-radius: 20px;
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4) !important;
}

/* 省略 h1, p 样式，与上一个版本相同... */
h1 {
  font-size: 48px;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

p {
  font-size: 18px;
  margin-bottom: 40px;
  line-height: 1.6;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 768px) {
  .hero {
    height: 300px;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    margin-bottom: 20px;
    line-height: 1.6;
  }

  .btnFindJob{
    padding: 4px 10px;
    margin-right: 10px;
    font-size: 12px;
  }

  .btnFindMember{
    padding: 4px 10px;
    margin-right: 10px;
    font-size: 12px;
  }
}
</style>
